import Cognito from './cognito'
import Api from './api'
import Video from './video'

export default {
  Cognito,
  Api,
  Video,
}
